import { ALL_AUDIENCE, MAX_AUDIENCES_PER_USER } from '@/domain/types/audience';
import { User } from '@/domain/types/user';

export type ValidationResult = { valid: boolean; message?: string };

/**
 * Firestore admite 30 valores en array-contains-any y uno lo ocupa el centinela
 * ALL, así que un usuario no puede pertenecer a más de 29 audiencias.
 * Es un techo real: superarlo hace fallar la consulta de la app en runtime.
 */
export function validateAudienceSelection(
  audienceIds: string[],
): ValidationResult {
  if (audienceIds.length > MAX_AUDIENCES_PER_USER) {
    return {
      valid: false,
      message: `Un usuario puede pertenecer a un máximo de ${MAX_AUDIENCES_PER_USER} audiencias.`,
    };
  }
  return { valid: true };
}

/**
 * Decide a quiénes de una selección se puede agregar a la audiencia. Quien ya
 * está en el máximo de audiencias queda en `rejected`; al resto se le devuelve
 * su lista de audiencias ya con la nueva incluida, sin duplicar.
 */
export function planAddition(
  users: User[],
  audienceId: string,
): { allowed: User[]; rejected: User[] } {
  const allowed: User[] = [];
  const rejected: User[] = [];
  for (const user of users) {
    const current = user.audienceIds ?? [];
    const next = current.includes(audienceId)
      ? current
      : [...current, audienceId];
    if (validateAudienceSelection(next).valid) {
      allowed.push({ ...user, audienceIds: next });
    } else {
      rejected.push(user);
    }
  }
  return { allowed, rejected };
}

/**
 * Traduce la selección del formulario al campo audienceIds de la publicación.
 * Sin selección significa pública, que se representa con el centinela ALL
 * (nunca con ausencia del campo: array-contains-any no devuelve documentos
 * que no tengan el campo).
 */
export function audienceIdsForPublication(selected: string[]): string[] {
  if (selected.length === 0) return [ALL_AUDIENCE];
  return Array.from(new Set(selected));
}
